/* global API_ROOT */
 
import { artistsFetch, artistFetch, clearArtist } from './'
import { tutorialsFetch } from '../tutorials'
import { webinarsFetch } from '../webinars'
import { blogPostsFetch } from '../blogPosts'
import { assetsFetch } from '../assets'

export const artistsMergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps
  return {
    ...stateProps,
    ...ownProps,
    loadArtists(filters) {
      dispatch(artistsFetch(filters)())
    }
  }
}

export const artistDispatchers = (dispatch, props) => ({
  loadArtistInfo() {
    dispatch(artistFetch(props.params.artistSlug)()).then(([_, res]) => {
      dispatch(blogPostsFetch({ author: res.payload.user })())
      dispatch(assetsFetch('artist', res.payload.id, 50)())
    })
  },
  loadArtistTutorials() {
    dispatch(tutorialsFetch({ artist: props.params.artistSlug })())
  },
  loadArtistWebinars() {
    dispatch(webinarsFetch({ artist: props.params.artistSlug })())
  },
  clearArtist() {
    dispatch(clearArtist())
  }
})
